import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CmsContentService } from '@digital-platform/rs-cms/services';
import { ConstantsModule } from './constants/constants.module';
import { LocationsUtilsService } from './services/locations-utils/locations-utils.service';
import { RedirectionService } from './services/redirection/redirection.service';

@NgModule({
  imports: [CommonModule, ConstantsModule],
  providers: [CmsContentService, RedirectionService, LocationsUtilsService],
})
export class RsFrontendLocationsRedirectModule {}
